/**
 * Constants for Int64
 *
 * @typedef {import('./Int64Type.js').BrandedInt64} BrandedInt64
 */

/** @type {-9223372036854775808n} Minimum Int64 value (-2^63) */
export const MIN = /** @type {any} */ (-9223372036854775808n);

/** @type {9223372036854775807n} Maximum Int64 value (2^63 - 1) */
export const MAX = /** @type {any} */ (9223372036854775807n);

/** @type {0n} Zero value */
export const ZERO = /** @type {any} */ (0n);

/** @type {1n} One value */
export const ONE = /** @type {any} */ (1n);

/** @type {-1n} Negative one value */
export const MINUS_ONE = /** @type {any} */ (-1n);

/** @type {8} Size in bytes */
export const SIZE = 8;
